import { IDialogController, IDialogCustomElementViewModel } from "@aurelia/dialog";
import { ICustomElementController } from "@aurelia/runtime-html";
import { ICreateProjectService, SizeObject } from "@components/create-project-dialog/services/create-project-service";
import { IFormInputOption } from "@components/form/interfaces/form-interface";
import { ModelTypes } from "@zeus";
import { inject, watch } from "aurelia";

@inject(ICreateProjectService)
export class ViewMoreImagesDialog implements IDialogCustomElementViewModel {
  private availableImages: ModelTypes["pTemplate"][] = []
  private selectedTemplate: ModelTypes["pTemplate"]
  private displayFormats: IFormInputOption[]
  private selectedFormat: string
  private formats: SizeObject[] = []

  $controller?: ICustomElementController<this>;
  $dialog: IDialogController;

  constructor(private service: ICreateProjectService) {

  }

  activate(viewMoreImagesDialogModel: {
    availableImages: ModelTypes['pTemplate'][]
    displayFormats: IFormInputOption[]
    selectedFormat: string
    formats: SizeObject[]
    selectedTemplate: ModelTypes["pTemplate"]
  }) {
    this.availableImages = viewMoreImagesDialogModel.availableImages
    this.displayFormats = viewMoreImagesDialogModel.displayFormats
    this.selectedFormat = viewMoreImagesDialogModel.selectedFormat
    this.formats = viewMoreImagesDialogModel.formats
    this.selectedTemplate = viewMoreImagesDialogModel.selectedTemplate
  }

  @watch('selectedFormat')
  private async getAvailableDisplays(): Promise<ModelTypes["pTemplate"][]> {
    if (!this.selectedFormat) return;

    const dimmension = this.formats.find(x => x.id === this.selectedFormat);

    const result = await this.service.getTemplates({ height: dimmension.height, width: dimmension.width });

    this.availableImages = result
  }

  selectTemplate(image) {
    this.selectedTemplate = image
  }

  advanceStep() {
    this.$dialog.ok({
      availableImages: this.availableImages,
      displayFormats: this.displayFormats,
      selectedFormat: this.selectedFormat,
      formats: this.formats,
      selectedTemplate: this.selectedTemplate,
    })
  }

}